// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/x-circle.svg. Do not edit.

import type { Glyph } from '../../types'

export const glyph: Glyph = {
  name: 'x-circle',
  version: 'outline',
  paths: [
    {
      d: 'm9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z',
    },
  ],
}
